import { CarePlanStepStatus } from "@/types/care-plan";

export const STATUS_LABELS: Record<CarePlanStepStatus, string> = {
  [CarePlanStepStatus.PENDING]: "Pending",
  [CarePlanStepStatus.SCHEDULED]: "Scheduled",
  [CarePlanStepStatus.COMPLETED]: "Completed",
  [CarePlanStepStatus.SKIPPED]: "Skipped",
  [CarePlanStepStatus.MISSED]: "Missed",
};

/** Mirrors backend ALLOWED_TRANSITIONS — only these transitions are valid. */
export const ALLOWED_TRANSITIONS: Record<
  CarePlanStepStatus,
  CarePlanStepStatus[]
> = {
  [CarePlanStepStatus.PENDING]: [CarePlanStepStatus.SKIPPED],
  [CarePlanStepStatus.SCHEDULED]: [
    CarePlanStepStatus.COMPLETED,
    CarePlanStepStatus.SKIPPED,
    CarePlanStepStatus.PENDING,
  ],
  [CarePlanStepStatus.MISSED]: [CarePlanStepStatus.PENDING],
  [CarePlanStepStatus.SKIPPED]: [CarePlanStepStatus.PENDING],
  [CarePlanStepStatus.COMPLETED]: [], // terminal
};

/** Long-form duration label for UI display (e.g. "2 days", "3 hrs", "30 min"). */
export function formatDurationLabel(minutes: number): string {
  if (minutes >= 1440) {
    const days = Math.round(minutes / 1440);
    return `${days} day${days !== 1 ? "s" : ""}`;
  }
  if (minutes >= 60) {
    const hours = Math.round(minutes / 60);
    return `${hours} hr${hours !== 1 ? "s" : ""}`;
  }
  return `${minutes} min`;
}

export function formatMinutes(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  if (minutes < 1440) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  }
  // 30-day months
  if (minutes % 43200 === 0) return `${minutes / 43200}mo`;
  // weeks
  if (minutes % 10080 === 0) return `${minutes / 10080}w`;
  const d = Math.floor(minutes / 1440);
  const rem = minutes % 1440;
  return rem > 0 ? `${d}d ${formatMinutes(rem)}` : `${d}d`;
}
